'use strict';exports.__esModule = true;exports.parsePrice = exports.getOptions = exports.getInitialOptionsConfig = exports.formatCompletionDate = exports.getYearsOptions = exports.getMonthsOptions = undefined;var _lodash = require('lodash');
var _moment = require('moment');var _moment2 = _interopRequireDefault(_moment);
var _constants = require('./constants');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var getMonthsOptions = exports.getMonthsOptions = function getMonthsOptions() {
  var monthsOptions = [];

  for (var i = 0; i < 12; i += 1) {
    monthsOptions.push({
      label: '' + (i < 9 ? 0 : '') + (i + 1),
      value: i + 1 });

  }

  return monthsOptions;
};

var getYearsOptions = exports.getYearsOptions = function getYearsOptions() {
  var yearsOptions = [];
  var newDate = new Date().getFullYear();
  var past = newDate - 5;
  var future = newDate + 10;

  for (var i = past; i <= future; i += 1) {
    yearsOptions.push({
      label: i,
      value: i });

  }

  return yearsOptions;
};

var formatCompletionDate = exports.formatCompletionDate = function formatCompletionDate(completion_month, completion_year) {
  var completion_date = void 0;

  if (completion_month) {
    var date = (0, _moment2.default)([completion_month, completion_year], ['M/YYYY']);
    completion_date = (0, _moment2.default)(date).
    endOf('day').
    toISOString();
  } else {
    var _date = (0, _moment2.default)(['2', '1', completion_year], ['D/M/YYYY']);
    completion_date = (0, _moment2.default)(_date).
    endOf('day').
    toISOString();
  }

  return completion_date;
};

var getInitialOptionsConfig = exports.getInitialOptionsConfig = function getInitialOptionsConfig(translate) {return Object.values(_constants.commodityOptionTypes).
  map(function (option) {return {
      value: option,
      label: translate('addNewProject', option),
      disabled: false };});};


var getOptions = exports.getOptions = function getOptions(arr, other, currentType, translate) {
  var fieldsValues = (0, _lodash.keyBy)(other, 'type');
  return arr.map(function (item) {return Object.assign({},
    item, {
      label: translate('addNewProject', item.value),
      disabled: item.value === currentType || !!fieldsValues[item.value] });});

};

var parsePrice = exports.parsePrice = function parsePrice(price) {
  if (typeof price === 'number') return price;
  if (!price) return undefined;

  return Number(price.replace(/,/g, ''));
};


//////////////////
// WEBPACK FOOTER
// ./src/containers/PublishNewHomesForm/helpers.js
// module id = 278
// module chunks = 0